module.exports = __webpack_public_path__ + "static/media/addPhoto.b1c5c49a.svg";